import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./About.css";
import "../pages/Responsive.css";
import innerbanner from "../assets/images/about-banner.png";
import aboutusimg from "../assets/images/about-us-img.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import EventIcon from "@mui/icons-material/Event";
import visionmissionimg from "../assets/images/vision-mision-img.png";
import CountUp from "react-countup";
import whatweoffer1 from "../assets/images/what-we-offer-1.png";
import whatweoffer2 from "../assets/images/what-we-offer-2.png";
import servicesicon from "../assets/images/services-icon.png";
import whyusicon from "../assets/images/why-us-icon.png";
import StarIcon from "@mui/icons-material/Star";

export default function About() {
  return (
    <>
      <Header />

      <div className="about_us_main">
        <div className="container-fluid">
          <div
            className="inner_banner_contact"
            style={{ backgroundImage: `url(${innerbanner})` }}
          >
            <div className="text_on_img">
              <div className="breadcrumb">
                <Link to="/">Home</Link>
                <span> &gt; </span>
                <Link to="/contact">About Us</Link>
              </div>
              <h1 className="bread_heading">
                Compassionate Home Healthcare Services You Can Trust
              </h1>
              <p className="bread_peraa">
                At CaresAtHome, we are committed to making quality healthcare
                accessible where it matters most—your home. With experienced
                healthcare professionals, we deliver compassionate, reliable,
                and personalized care that enhances recovery and improves
                quality of life.
              </p>
            </div>
          </div>

          <div className="about_us_first_sec">
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12">
                <div className="img_and_text_about">
                  <span className="vertical_text">CARESATHOME</span>
                  <div className="about_img">
                    <img src={aboutusimg} alt="About" />
                  </div>
                </div>
              </div>
              <div className="col-lg-7 col-md-7 col-12">
                <div className="about_content">
                  <p className="title-about">About Us</p>
                  <h2 className="heading-about">
                    Caring Beyond <span>Healthcare</span>
                  </h2>
                  <p className="pera-about">
                    Founded by Mr. Madhukar Pareek (M.Sc. Nursing – Community
                    Health), CaresAtHome delivers trusted home healthcare
                    services with compassion and professionalism. Our
                    experienced doctors, nurses, physiotherapists, and
                    caregivers provide personalized medical care, elderly
                    support, rehabilitation, post-operative care, and critical
                    care services, ensuring safe, comfortable, and quality
                    healthcare in the comfort of your home.
                  </p>

                  <div className="about_bullet_points">
                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h3>Hospital-Level Medical Support</h3>
                        <p>
                          Receive professional nursing care, physiotherapy,
                          diagnostics, and medical assistance delivered with the
                          highest standards of clinical excellence.
                        </p>
                      </div>
                    </div>

                    <div className="about_point-self">
                      <CheckCircleIcon />
                      <div className="head_pera_about">
                        <h3>Personalized Home Care</h3>
                        <p>
                          Every care plan is customized according to the
                          patient's health condition, recovery goals, and
                          lifestyle for better outcomes and comfort.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="call_us_btn">
                    <div className="call_us_about">
                      <HeadsetMicIcon />
                      <div className="call_text">
                        <p>Call Us Anytime</p>
                        <a href="tel:+918739990555">+91-95211-11603</a>
                      </div>
                    </div>
                    <div className="book_aboutbtn">
                      <Link to="/home-nursingcare">Need Caregiver</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="vision_mission_section">
            <p className="title-about">Vision & Mission</p>
            <h3 className="heading-about">
              <span>Our vision and Mission: </span> Delivering Compassionate,
              Skilled, and Trusted Home Healthcare
            </h3>
            <div className="row">
              <div className="col-lg-6 col-md-12 col-12">
                <p className="vision-pera">
                  To become the most trusted provider of home healthcare
                  services, empowering individuals to recover, heal, and live
                  healthier lives through compassionate, accessible, and
                  high-quality care at home.
                </p>
              </div>
              <div className="col-lg-6 col-md-12 col-12">
                <p className="vision-pera">
                  Our mission is to deliver safe, affordable, and
                  patient-focused healthcare services by combining experienced
                  medical professionals, advanced healthcare solutions, and
                  personalized treatment plans that enhance recovery and improve
                  quality of life.
                </p>
              </div>
            </div>
            <div className="vision_mission_img">
              <img src={visionmissionimg} alt="" />
            </div>
          </div>

          <div className="what_we_offer">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="img_count_offer">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="count_first_about">
                        <h3>
                          <CountUp
                            end={200}
                            duration={3}
                            enableScrollSpy
                            scrollSpyOnce
                          />
                          +
                        </h3>
                        <p>Trusted & Verified Healthcare Professionals</p>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="img_first_offer">
                        <img src={whatweoffer1} alt="" />
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="img_second_offer">
                        <img src={whatweoffer2} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-12">
                <div className="what_we_offer_content_container">
                  <div className="what_we_offer_content">
                    <p className="title-about">What We Offer</p>
                    <h3 className="heading-about">
                      Comprehensive <span> Home Healthcare </span> Services
                    </h3>
                    <p className="pera-about">
                      We provide a complete range of healthcare solutions
                      designed to meet the medical needs of patients in the
                      comfort of their homes.
                    </p>
                  </div>
                  <div className="services_box_about">
                    <img src={servicesicon} alt="services-icon" />
                    <h3>Experienced Healthcare Professionals</h3>
                    <p>
                      Our skilled doctors, nurses, physiotherapists, and
                      caregivers deliver personalized care with professionalism,
                      compassion, and dedication.
                    </p>
                  </div>

                  <div className="services_box_about">
                    <img src={servicesicon} alt="services-icon" />
                    <h3>Nursing Care at Home</h3>
                    <p>
                      Professional nursing services for post-surgical care,
                      chronic illness management, injections, wound care, and
                      elderly support.
                    </p>
                  </div>

                  <div className="services_box_about">
                    <img src={servicesicon} alt="services-icon" />
                    <h3>Physiotherapy at Home</h3>
                    <p>
                      Customized rehabilitation programs to improve mobility,
                      reduce pain, and accelerate recovery after surgery or
                      injury.
                    </p>
                  </div>

                  <div className="services_box_about">
                    <img src={servicesicon} alt="services-icon" />
                    <h3>Home Diagnostics</h3>
                    <p>
                      Convenient home sample collection and accurate diagnostic
                      testing with timely digital reports.
                    </p>
                  </div>

                  <div className="services_box_about">
                    <img src={servicesicon} alt="services-icon" />
                    <h3>ICU & Critical Care at Home</h3>
                    <p>
                      Hospital-grade ICU setup with advanced medical equipment
                      and trained healthcare professionals for critical
                      patients.
                    </p>
                  </div>

                  <div className="services_box_about">
                    <img src={servicesicon} alt="services-icon" />
                    <h3>Medical Equipment Support</h3>
                    <p>
                      Reliable home delivery of oxygen concentrators, hospital
                      beds, wheelchairs, suction machines, and more.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="why_choose_us">
            <div className="title_and_pera_section">
              <p className="title-about">Why Choose CaresAtHome?</p>
              <h3 className="heading-about">
                Quality <span>Healthcare</span>, Right at Your Doorstep
              </h3>
            </div>
            <div className="why_choose_us_box_section">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-12">
                  <div className="why_us_box">
                    <div className="count_icon_whyus">
                      <div className="count_why_us">
                        <h3>
                          <CountUp
                            end={35}
                            duration={3}
                            enableScrollSpy
                            scrollSpyOnce
                          />
                          +
                        </h3>
                        <p>
                          <span>●</span> Experienced Professionals
                        </p>
                      </div>
                      <div className="icon_why_us">
                        <img src={whyusicon} alt="whay-us-icon" />
                      </div>
                    </div>
                    <p className="count_box_lower_pera">
                      Our qualified doctors, nurses, and caregivers bring years
                      of clinical expertise and compassionate support to every
                      patient.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-12">
                  <div className="why_us_box">
                    <div className="count_icon_whyus">
                      <div className="count_why_us">
                        <h3>
                          <CountUp
                            end={35}
                            duration={3}
                            enableScrollSpy
                            scrollSpyOnce
                          />
                          +
                        </h3>
                        <p>
                          <span>●</span> Trusted & Reliable Service
                        </p>
                      </div>
                      <div className="icon_why_us">
                        <img src={whyusicon} alt="whay-us-icon" />
                      </div>
                    </div>
                    <p className="count_box_lower_pera">
                      From emergency support to long-term care, we are committed
                      to delivering timely, safe, and dependable healthcare
                      services.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-12">
                  <div className="why_us_box">
                    <div className="count_icon_whyus">
                      <div className="count_why_us">
                        <h3>
                          <CountUp
                            end={35}
                            duration={3}
                            enableScrollSpy
                            scrollSpyOnce
                          />
                          +
                        </h3>
                        <p>
                          <span>●</span> Experienced Doctors
                        </p>
                      </div>
                      <div className="icon_why_us">
                        <img src={whyusicon} alt="whay-us-icon" />
                      </div>
                    </div>
                    <p className="count_box_lower_pera">
                      Our team of experienced doctor dedicated to providing
                      expert medical care with.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottom_sec_whyus">
              <p>
                Browse all professional healthcare services available for you
                and your family
              </p>
              <div className="rating_section">
                <span>Trusted By 600 + Users</span>

                <div className="divider"></div>

                <div className="rating">
                  <StarIcon />
                  <StarIcon />
                  <StarIcon />
                  <StarIcon />
                  <StarIcon />
                  <span>4.9/5</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
